import React, { useState } from "react";

const FAQ_DATA = [
  {
    title: "B01 & B01 Lite",
    items: [
      {
        question: "Qu'est-ce que le B01 ?",
        answer:
          "Le B01 est un boitier de sécurité conçu pour les vélos et trottinettes. " +
          "Il combine design moderne et fonctionnalités avancées pour assurer la sécurité " +
          "et le confort des utilisateurs pendant leurs trajets."
      },
      {
        question: "Quelles sont les principales fonctionnalités du B01 ?",
        answer: (
          <div>
            <p>Le B01 intègre plusieurs fonctionnalités essentielles dans un appareil compact :</p>
            <ul>
              <li>
                <strong>Alarme antivol</strong> : Alerte sonore en cas de tentative de vol.
              </li>
              <li>
                <strong>Détecteur de chute</strong> : Détection automatique des chutes pour
                assurer une assistance rapide grâce à vos contacts d'urgence.
              </li>
              <li>
                <strong>Bouton SOS</strong> : Possibilité d'alerter vos contacts d'urgence en cas
                de problème (agression, malaise...).
              </li>
              <li>
                <strong>Avertisseur sonore</strong> : Signale votre présence aux autres usagers
                de la route.
              </li>
            </ul>
          </div>
        ),
      },
      {
        question: "Comment utiliser les fonctionnalités depuis le B01 ?",
        answer:
          "Nous avons confectionné des minis vidéos pour expliquer pas à pas comment utiliser " +
          "et paramétrer votre B01. Rendez vous sur la page Notice du site internet."
      },
      {
        question: "Quels sont les matériaux utilisés pour le B01 ?",
        answer:
          "Le B01 est fabriqué à partir de matériaux robustes : ABS et polycarbonate " +
          "pour une résistance accrue, avec un anneau en aluminium anodisé."
      },
      {
        question: "Le B01 est-il résistant aux intempéries ?",
        answer:
          "Oui, le B01 est conçu pour résister aux conditions météorologiques difficiles, " +
          "il est certifié IP65."
      },
      {
        question: "Le B01 est-il facile à utiliser ?",
        answer:
          "Absolument ! Le B01 est équipé de boutons ergonomiques pour une manipulation intuitive " +
          "et peut également être contrôlé via une application mobile dédiée."
      },
      {
        question: "Quelles sont les dimensions et le poids du B01 ?",
        answer: "Le B01 mesure 86 mm x 46 mm x 15 mm et pèse 70 g."
      },
      {
        question: "Quelles couleurs sont disponibles pour le B01 ?",
        answer: "Le B01 est actuellement disponible en noir, pour un design épuré et intemporel."
      },
      {
        question: "Comment fonctionne l'alarme antivol ?",
        answer:
          "L'alarme se déclenche dès qu'une tentative de vol est détectée, " +
          "émettant un signal sonore puissant pour dissuader les voleurs."
      },
      {
        question: "Le B01 est-il compatible avec tous les téléphones ?",
        answer:
          "Le B01 est contrôlable via une application mobile compatible " +
          "avec la plupart des smartphones iOS et Android."
      },
      {
        question: "Le B01 peut-il envoyer une notification d'urgence automatiquement ?",
        answer:
          "Oui, en cas de chute détectée, le B01 peut automatiquement envoyer " +
          "une notification d'urgence à trois contacts préconfigurés."
      },
      {
        question: "Où puis-je acheter le B01 ?",
        answer:
          "Le B01 est disponible à l'achat sur notre site officiel et chez certains revendeurs agréés."
      },
      {
        question: "Le B01 est-il facile à installer sur un vélo ?",
        answer:
          "Oui, grâce à la fixation SMARTFIX (une fixation connectée, sécurisée sans outils)."
      },
      {
        question: "Le B01 est-il rechargeable ?",
        answer: "Oui, le B01 est équipé d'une batterie rechargeable."
      },
      {
        question: "Quelle est l'autonomie de la batterie du B01 ?",
        answer:
          "Le B01 offre une autonomie de plusieurs jours en utilisation normale, selon la fréquence " +
          "d’utilisation des fonctionnalités (alarme, appel d'urgence...)."
      },
      {
        question: "Comment savoir quand recharger le B01 ?",
        answer:
          "Le B01 est équipé d’un indicateur de batterie faible. Vous pouvez également suivre " +
          "l'état de la batterie depuis l'application mobile."
      },
      {
        question: "Le B01 nécessite-t-il un abonnement ?",
        answer:
          "Non, le B01 n’a pas besoin d’abonnement. Certaines fonctionnalités " +
          "(appels d’urgence) nécessitent toutefois votre smartphone en Bluetooth."
      },
      {
        question: "Le B01 est-il compatible avec des vélos électriques ?",
        answer:
          "Oui, le B01 peut être utilisé avec tous types de vélos (sauf route), y compris les vélos électriques."
      },
      {
        question:
          "Quelle est la portée de la connexion Bluetooth entre le B01 et l’application mobile ?",
        answer:
          "La portée maximale est d’environ 10 mètres, selon l'environnement et les interférences."
      },
      {
        question:
          "Le B01 est-il compatible avec les systèmes d’assistance vocale (Siri, Google Assistant) ?",
        answer:
          "Le B01 n'est pas directement compatible avec ces assistants, mais il est contrôlé " +
          "via l’app Baltee. Selon votre smartphone, certaines intégrations peuvent exister."
      },
      {
        question: "Le B01 fonctionne-t-il en dehors de la couverture réseau mobile ?",
        answer:
          "Les fonctionnalités liées aux appels d'urgence et au détecteur de chute nécessitent " +
          "une connexion à votre smartphone et donc un réseau pour envoyer l’e-mail ou SMS d’urgence."
      },
    ],
  },
  {
    title: "SMARTFIX",
    items: [
      {
        question: "Qu'est-ce que la SMARTFIX ?",
        answer:
          "La SMARTFIX est un système de fixation innovant spécialement conçu pour le B01, " +
          "permettant une installation rapide et sécurisée."
      },
      {
        question: "Comment fonctionne la SMARTFIX ?",
        answer:
          "Le système SMARTFIX permet de fixer ou retirer le B01 d’un simple quart de tour. " +
          "Elle ne peut être déverrouillée que par le propriétaire via l’application Baltee Mobility."
      },
      {
        question: "Où peut-on installer la SMARTFIX sur le vélo ?",
        answer:
          "La SMARTFIX est conçue pour être attachée aussi bien à droite qu’à gauche du guidon, " +
          "et ce en position horizontale ou verticale."
      },
      {
        question: "Comment verrouiller le B01 sur la SMARTFIX ?",
        answer:
          "Pour verrouiller et activer l'alarme antivol, positionnez le B01 en position verticale. " +
          "En position horizontale, le B01 n’est pas verrouillé."
      },
      {
        question: "Quelles sont les dimensions et le poids de la SMARTFIX ?",
        answer:
          "La SMARTFIX pèse environ 25 g et son diamètre intérieur est de 22 mm, " +
          "compatible avec la plupart des guidons standard."
      },
      {
        question: "Quels matériaux sont utilisés pour la SMARTFIX ?",
        answer: "La SMARTFIX est fabriquée en aluminium et ABS, garantissant robustesse et légèreté."
      },
      {
        question: "Est-ce que la SMARTFIX est disponible dans plusieurs couleurs ?",
        answer:
          "La SMARTFIX est actuellement disponible en noir, pour un design sobre et moderne, " +
          "coordonné au B01."
      },
      {
        question: "La SMARTFIX est-elle compatible avec tous les vélos ?",
        answer:
          "La SMARTFIX est compatible avec la plupart des vélos ayant un guidon de 22 mm de diamètre."
      },
      {
        question: "Puis-je changer la position du B01 une fois installé avec la SMARTFIX ?",
        answer:
          "Oui, vous pouvez ajuster la position du B01 (gauche, droite, horizontale, verticale) " +
          "à l’aide de la clé Allen fournie."
      },
      {
        question: "La SMARTFIX est-elle résistante aux intempéries ?",
        answer:
          "Oui, fabriquée à partir de matériaux résistants, la SMARTFIX fonctionne sous la pluie " +
          "ou dans des conditions difficiles."
      },
      {
        question: "La SMARTFIX nécessite-t-elle des outils pour l'installation ?",
        answer:
          "L’installation est simple, sans outil spécifique. Seule une clé Allen fournie est nécessaire."
      },
      {
        question: "Comment la SMARTFIX améliore-t-elle la sécurité du B01 ?",
        answer:
          "Elle ne peut être déverrouillée que via l’application par le propriétaire, " +
          "ce qui renforce la protection contre le vol."
      },
      {
        question:
          "Est-il possible de verrouiller la SMARTFIX manuellement sans l'application ?",
        answer:
          "Non, le verrouillage/déverrouillage se fait exclusivement via l’app Baltee Mobility."
      },
      {
        question:
          "La SMARTFIX peut-elle être utilisée avec des trottinettes ou scooters ?",
        answer:
          "Si le diamètre du guidon est de 22 mm, c’est possible, mais il est recommandé de vérifier " +
          "la compatibilité avant."
      },
      {
        question: "Que faire si la SMARTFIX est endommagée ou défectueuse ?",
        answer:
          "Contactez le SAV Baltee pour un remplacement ou une réparation (sous garantie, si applicable)."
      },
      {
        question: "Est-il possible d'acheter plusieurs SMARTFIX pour un seul B01 ?",
        answer:
          "Oui, vous pouvez en acheter plusieurs pour installer le B01 sur différents vélos. " +
          "L’app Baltee Mobility permet de gérer plusieurs fixations."
      },
      {
        question: "La SMARTFIX peut-elle être utilisée en environnement urbain ?",
        answer:
          "Oui, elle est conçue pour résister aux vibrations fréquentes et aux intempéries de la vie urbaine."
      },
      {
        question: "Y a-t-il un risque que la SMARTFIX se desserre avec le temps ?",
        answer:
          "Elle est conçue pour rester bien fixée. Si vous remarquez un desserrage, vérifiez " +
          "et resserrez si nécessaire."
      },
      {
        question: "La SMARTFIX interfère-t-elle avec d'autres accessoires de guidon ?",
        answer:
          "Elle est compacte et ne devrait pas gêner la plupart des accessoires (sonnette, lumière...). " +
          "Vérifiez l’espace disponible sur votre guidon."
      },
      {
        question:
          "La SMARTFIX peut-elle être utilisée dans un cadre de compétition ou cyclisme sportif ?",
        answer:
          "Elle est plutôt conçue pour un usage quotidien et urbain, mais sa légèreté " +
          "et sa robustesse la rendent utilisable pour divers types de trajets."
      },
    ],
  },
  {
    title: "App mobile",
    items: [
      {
        question: "Qu'est-ce que l'application Baltee Mobility ?",
        answer:
          "C’est l’app qui gère les dispositifs Baltee (B01, SMARTFIX…). " +
          "Elle permet la sécurité, la navigation et différentes fonctionnalités connectées pour cyclistes."
      },
      {
        question: "Quelles fonctionnalités propose l'application Baltee Mobility ?",
        answer: (
          <div>
            <p>Plusieurs fonctionnalités clés :</p>
            <ul>
              <li>
                <strong>Contrôle de la fixation SMARTFIX</strong> : Verrouillage et déverrouillage
                sécurisé du B01.
              </li>
              <li>
                <strong>Gestion des contacts d’urgence</strong> : Configuration de vos contacts
                (chute, bouton SOS).
              </li>
              <li>
                <strong>Localisation GPS</strong> : Localisation du dernier point GPS (via l’appli).
              </li>
              <li>
                <strong>Contrôle du B01</strong> : Activation de l’alarme, avertisseur sonore etc.
              </li>
            </ul>
          </div>
        ),
      },
      {
        question:
          "L'application Baltee est-elle compatible avec tous les smartphones ?",
        answer:
          "Elle est compatible avec la plupart des smartphones iOS (v. 11+) et Android (v. 6+)."
      },
      {
        question: "Comment puis-je associer mon B01 à l'application Baltee ?",
        answer:
          "Après avoir téléchargé l’application, vous associez votre B01 via Bluetooth " +
          "en suivant les instructions ; il sera lié à votre compte."
      },
      {
        question: "Est-il possible d'ajouter plusieurs appareils dans l'application ?",
        answer:
          "Oui, vous pouvez ajouter plusieurs dispositifs Baltee à un même compte " +
          "et les gérer indépendamment."
      },
      {
        question: "Comment configurer les contacts d'urgence dans l'application ?",
        answer:
          "Vous ajoutez jusqu’à trois contacts. En cas de chute détectée ou SOS, " +
          "l’appli envoie un e-mail / SMS d’alerte."
      },
      {
        question: "Que faire si je perds mon téléphone ?",
        answer:
          "Installez l’appli sur un nouveau téléphone, connectez-vous avec vos identifiants. " +
          "Tous vos réglages seront synchronisés."
      },
      {
        question:
          "L'application Baltee nécessite-t-elle une connexion Internet pour fonctionner ?",
        answer:
          "Oui, l’application nécessite une connexion internet pour la synchronisation, " +
          "l’envoi d’alertes etc."
      },
      {
        question: "L'application est-elle gratuite ?",
        answer:
          "Oui, l’appli est gratuite. Certaines fonctionnalités avancées " +
          "pourraient nécessiter un abonnement dans le futur."
      },
      {
        question: "Comment mettre à jour l'application et le firmware du B01 ?",
        answer:
          "L’appli se met à jour via l’App Store ou Google Play. Pour le B01, " +
          "une notification vous indiquera la mise à jour du firmware."
      },
      {
        question: "Que faire en cas de problème technique avec l'application ?",
        answer:
          "Vous pouvez contacter le support Baltee via le formulaire SAV. " +
          "Notre équipe vous aidera à résoudre le problème."
      },
      {
        question: "L'application fonctionne-t-elle sans connexion Bluetooth ?",
        answer:
          "Non, pour interagir avec B01 ou SMARTFIX, il faut la connexion Bluetooth activée."
      },
      {
        question: "Comment puis-je supprimer un appareil de l'application ?",
        answer:
          "Dans vos paramètres, sélectionnez le dispositif à retirer et suivez les étapes de dissociation."
      },
      {
        question: "L'application protège-t-elle mes données personnelles ?",
        answer:
          "Oui, Baltee applique des normes strictes de confidentialité et de sécurité. " +
          "Vos données restent privées."
      },
    ],
  },
  {
    title: "Livraison et garantie",
    items: [
      {
        question: "Offrez-vous la livraison gratuite ?",
        answer:
          "Oui, nous proposons la livraison gratuite sur toutes les commandes, sans montant minimum."
      },
      {
        question: "Quels sont les délais d'expédition ?",
        answer:
          "Toutes les commandes passées avant 14h (jour ouvré) sont expédiées sous 24h. " +
          "Après 14h ou week-end, expédition le jour ouvré suivant."
      },
      {
        question: "Quels sont les délais de livraison ?",
        answer:
          "Généralement, comptez 2 à 5 jours ouvrés après expédition, selon la destination."
      },
      {
        question: "Quels sont les modes de livraison ?",
        answer:
          "Nous proposons plusieurs modes gratuits (Colissimo relais, point Pickup…). " +
          "Vous pouvez aussi opter pour la livraison à domicile avec signature à 2,99€."
      },
      {
        question: "Offrez-vous une garantie sur vos produits ?",
        answer:
          "Oui, tous nos produits sont couverts par une garantie de 1 an à partir de la date d'achat."
      },
      {
        question: "Comment fonctionne la garantie d'un an ?",
        answer:
          "En cas de problème sous garantie, contactez le SAV. Nous procéderons " +
          "à un échange, une réparation ou un remboursement selon le cas."
      },
      {
        question: "Comment puis-je contacter le service après-vente (SAV) ?",
        answer:
          "Via notre formulaire de contact en ligne, ou par e-mail à SAV@baltee.com. " +
          "Notre équipe vous assistera."
      },
      {
        question: "Comment puis-je suivre ma commande ?",
        answer:
          "Après expédition, vous recevez un numéro de suivi par e-mail pour suivre votre colis."
      },
      {
        question: "Proposez-vous des livraisons internationales ?",
        answer: "Non, nous livrons uniquement en France."
      },
      {
        question: "Puis-je modifier ou annuler ma commande après l'avoir passée ?",
        answer:
          "Oui, tant qu'elle n'a pas été expédiée. Contactez rapidement notre service client."
      },
      {
        question: "Que faire si je reçois un produit défectueux ou incorrect ?",
        answer:
          "Contactez immédiatement notre SAV. Nous organiserons un remplacement ou un remboursement."
      },
      {
        question: "Quels moyens de paiement acceptez-vous ?",
        answer:
          "Nous acceptons les cartes bancaires (Visa, MasterCard) et PayPal. Tous les paiements sont sécurisés."
      },
      {
        question: "Où puis-je trouver mes factures ?",
        answer:
          "Vos factures sont disponibles dans votre compte client. Vous pouvez les télécharger à tout moment."
      },
      {
        question: "Que se passe-t-il si je ne suis pas chez moi lors de la livraison ?",
        answer:
          "Un avis de passage sera déposé. Vous pourrez reprogrammer la livraison ou récupérer le colis au point relais."
      },
      {
        question: "Que faire si j’oublie mon mot de passe ?",
        answer:
          "Cliquez sur « Mot de passe oublié » à la connexion. Vous recevrez un e-mail " +
          "avec un lien pour réinitialiser."
      },
    ],
  },
];

/**
 * Composant FAQPage
 */
export default function FAQPage() {
  // Pour gérer l'état "ouvert/fermé" de chaque question, on peut :
  // - soit gérer un useState par item,
  // - soit un useState qui retient l'index actif par catégorie,
  // - ou un state global pour tout (id + bool).
  // Ici, on fera simple : on stocke un objet {catIndex -> [bool, bool, ...]}
  // pour chaque question d'une catégorie.

  // Initialisons un state qui contient pour chaque catégorie, un tableau
  // de false. (false => accordéon fermé, true => accordéon ouvert)
  const initialAccordionsState = FAQ_DATA.map((category) =>
    category.items.map(() => false)
  );

  const [accordionsState, setAccordionsState] = useState(initialAccordionsState);

  // Fonction pour toggler (ouvrir/fermer) un item particulier
  const handleToggle = (catIndex, itemIndex) => {
    setAccordionsState((prev) => {
      const newState = [...prev];
      // on copie le tableau de la catégorie
      const catArray = [...newState[catIndex]];
      catArray[itemIndex] = !catArray[itemIndex];
      newState[catIndex] = catArray;
      return newState;
    });
  };

  return (
    <div style={{ maxWidth: "800px", margin: "0 auto", padding: "2rem" }}>
      <h1>Foire aux questions (FAQ)</h1>
      <p>
        Retrouvez ci-dessous les réponses aux questions les plus fréquemment posées
        concernant Baltee Mobility, le B01, la SMARTFIX, l’application mobile,
        ainsi que les informations liées à la livraison et à la garantie.
      </p>

      {FAQ_DATA.map((category, catIndex) => (
        <div key={catIndex} style={{ marginTop: "2rem" }}>
          <h2>{category.title}</h2>
          {category.items.map((item, itemIndex) => {
            const isOpen = accordionsState[catIndex][itemIndex];
            return (
              <div
                key={`${catIndex}-${itemIndex}`}
                style={{
                  borderBottom: "1px solid #ccc",
                  marginBottom: "0.5rem",
                  paddingBottom: "0.5rem",
                }}
              >
                <button
                  onClick={() => handleToggle(catIndex, itemIndex)}
                  style={{
                    background: "none",
                    border: "none",
                    textAlign: "left",
                    width: "100%",
                    cursor: "pointer",
                    padding: "0.5rem 0",
                    fontSize: "1rem",
                    fontWeight: "bold",
                  }}
                >
                  {item.question}
                  <span style={{ float: "right" }}>
                    {isOpen ? "▲" : "▼"}
                  </span>
                </button>
                {isOpen && (
                  <div style={{ marginTop: "0.5rem" }}>{item.answer}</div>
                )}
              </div>
            );
          })}
        </div>
      ))}
    </div>
  );
}
